import { Container } from "@mui/material";
import Header from "./components/Header";
import CompareField from "./components/CompareField";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

const App = () => (
  <>
    <Header />
    <Container maxWidth="lg">
      <AuthenticatedTemplate>
        <CompareField />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        Please <b>login</b> to access this application
      </UnauthenticatedTemplate>
    </Container>
  </>
);

export default App;
